import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { CSVLink } from "react-csv";
import { HiEmojiSad } from 'react-icons/hi';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom'
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai"
import axios from 'axios';
import "../App.css"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BiLink } from "react-icons/bi"
import Popup from 'reactjs-popup';
import { useForm } from 'react-hook-form';
import MoonLoader from "react-spinners/MoonLoader";

function ManageFSTeachers({ IP, TOKEN }) {

    const navigate = useNavigate()
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [isLoading, setLoading] = useState(false)
    const [teachers, setTeachers] = useState([])
    const [search, setSearch] = useState("")
    const [filteredList, setFilteredList] = useState([])
    const [selectedRows, setSeletedRows] = useState([])
    const [selectedPSY, setPSY] = useState("2022")
    const [selectedCollege, setCollege] = useState("")
    const [selectedStdyr, setStdYear] = useState("")
    const [studentYears, setStudentYears] = useState([])
    const [colleges, setColleges] = useState([])
    const [selectedSem, setSemester] = useState("")
    const [semesters, setSemesters] = useState([])

    const keys = ["name", "username", "college", "updatedon", "fsname"] // keys for search

    useEffect(() => {
        fetchFsTeachers()
    }, [])

    const fetchFsTeachers = async () => {
        setLoading(true)
        await axios.get(`http://${IP}/fs-teachers/${TOKEN}`)
            .then(res => {
                setFilteredList(res.data.TeachersListObj);
                setTeachers(res.data.TeachersListObj);
                setLoading(false);
            }
            )
            .catch(err => console.log(err))
    }

    useEffect(() => {
        const data = teachers.filter((Obj) => keys.some((key) => { return Obj[key].toLowerCase().includes(search.toLowerCase()) }))
        setFilteredList(data);
    }, [search])

    //export
    const headers = [
        { label: "Name", key: "name" },
        { label: "Username", key: "username" },
        { label: "FSBatchID", key: "fsbatchid" },
        { label: "College", key: "college" },
        { label: "UpdatedOn", key: "updatedon" },
    ];

    const csvReport = {
        filename: "FS_Teachers.csv",
        headers: headers,
        data: filteredList
    }

    const editRow = (rowData) => {
        console.log("edit")
    }

    const deleteRow = async (username) => {
        await axios.delete(`http://${IP}/delete-fs-teacher/${TOKEN}/${username}`)
            .then(res => {
                if (res.data.msg == "Deleted successfully") {
                    notifySuccess(res.data.msg)
                    setCollege("")
                    setColleges([])
                    fetchFsTeachers()
                }
                else if (res.data.msg == "Data not found") {
                    notifyError(res.data.msg)
                }
            })
            .catch((err) => console.log(err))
    }

    const columns = [
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
            width: "170px",
        },
        {
            name: "Username",
            selector: (row) => row.username,
            sortable: true,
            width: "250px",
        },
        {
            name: "FSBatch Name",
            selector: (row) => row.fsname,
            sortable: true,
            width: "180px",
        },
        {
            name: "College",
            selector: (row) => row.college,
            sortable: true,
            width: "200px",
        },
        {
            name: "Updated on",
            selector: (row) => row.updatedon,
            sortable: true,
            width: "240px",
        },
        {
            name: "Actions",
            selector: (row) =>
                <div>
                    <button className='btn btn-sm btn-primary me-2' onClick={() => editRow(row)}><AiOutlineEdit className='mb-1' /></button>
                    <Popup trigger={<button className='btn btn-sm btn-danger'><AiOutlineDelete className='mb-1' /></button>} position="top center">
                        <div className='bg-white p-2 text-center rounded popup-delete'>
                            <h6>Are you sure?</h6>
                            <button className='btn btn-sm btn-danger mt-2' onClick={() => deleteRow(row.username)}>Delete</button>
                        </div>
                    </Popup>
                </div>,
            sortable: true,
            width: "110px",
        },
    ]

    // const addProject = async (formData) => {
    //     await axios.post(`http://${IP}/add-project`, formData)
    //         .then(res => {
    //             if (res.data.msg === "Project details added successfully") {
    //                 notifySuccess(res.data.msg);
    //                 setShow1(false);                    
    //                 setSeletedRows([])
    //                 setSearch("")
    //             }
    //             else if (res.data.msg === "Project already exists with same title and college") {
    //                 notifyError(res.data.msg)
    //             }
    //         })
    //         .catch(err => console.log(err))
    // }

    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    const [rowData, setRowData] = useState({})

    const handleClose = () => {
        setShow(false);
        setShow1(false);
    }

    const handleSelectedRow = (data) => {
        setRowData(data)
        setShow(true)
    }

    const rowsSelected = (rows) => {
        setSeletedRows(rows.selectedRows)
        // console.log(rows.selectedRows)
    }

    const gotoUploadFsTeachers = () => {
        navigate("/upload/fs-teachers")
    }

    const addButton = () => {
        setShow1(true)
    }

    const notifySuccess = (msg) => {
        toast.success(msg, {
            toastId: 1,
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            width: "fit-content"
        });
    }

    const notifyWarning = (msg) => {
        toast.warn(msg, {
            toastId: 2,
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            width: "fit-content"
        });
    }

    const notifyError = (msg) => {
        toast.error(msg, {
            toastId: 3,
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            width: "fit-content"
        });
    }

    return (
        <div className='container-fluid'>

            {/* <Modal show={show} onHide={handleClose} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title><h6>Project Details</h6></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <table>
                        <tr>
                            <td className="align-baseline pb-2 text-muted" style={{ width: "120px" }}>Project Id : </td>
                            <td className="pb-3">{rowData.ProjectId}</td>
                        </tr>
                        <tr>
                            <td className="align-baseline pb-3 text-muted" style={{ width: "120px" }}>Project Title : </td>
                            <td className="pb-3" style={{ textAlign: "justify" }}>{rowData.ProjectTitle}</td>
                        </tr>
                        <tr>
                            <td className="align-baseline pb-3 text-muted" style={{ width: "120px" }}>Category : </td>
                            <td className="pb-3">{rowData.Category}</td>
                        </tr>
                        <tr>
                            <td className="align-baseline pb-3 text-muted" style={{ width: "120px" }}>Technologies : </td>
                            <td className="pb-3">{rowData.Technologies}</td>
                        </tr>
                        <tr>
                            <td className="align-baseline pb-3 text-muted" style={{ width: "120px" }}>Problem Statement : </td>
                            <td className="pb-3" style={{ textIndent: "30px", textAlign: "justify" }}>
                                <div className="popup-desciption">
                                    {rowData.ProblemStatement}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="align-baseline pb-3 text-muted" style={{ width: "120px" }}>Group(s) : </td>
                            <td className="pb-3">{rowData.Groups}</td>
                        </tr>
                        <tr>
                            <td className="align-baseline pb-3 text-muted" style={{ width: "120px" }}>Ref Link : </td>
                            <td className="pb-3"><a href={rowData.RefLink} target="_blank" > <BiLink className='link-icon' /></a></td>
                        </tr>
                        <tr>
                            <td className="align-baseline pb-3 text-muted" style={{ width: "120px" }}>Last Modified : </td>
                            <td className="pb-3">{rowData.lastModified}</td>
                        </tr>
                    </table>
                </Modal.Body>
            </Modal> */}
            {/* <div className='m-auto' style={{ maxWidth: "1300px" }}>
                <h6 className='mt-2 pt-2'>Filter By</h6>
                <div className='row'>
                    <div className='form-group mt-1 col-lg-2 col-md-4 col-sm-4 col-4 '>
                        <label htmlFor='PSY' className='me-2'><small>PS Year</small></label>
                        <select className='form-select form-select-sm' id="PSY" onChange={event => setPSYfunction(event.target.value)}>
                            <option defaultChecked value="2022">2022</option>
                            <option value="2023">2023</option>
                            <option value="2024">2024</option>
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                        </select>
                    </div>
                    <div className="form-group mt-1 col-lg-2 col-md-4 col-sm-4 col-4">
                        <label htmlFor='college' className='me-2'><small>College</small></label>
                        <select className='form-select form-select-sm' id="college" onChange={event => setCollegefunction(event.target.value)}>
                            <option defaultChecked value="all">Select college...</option>
                            {
                                colleges.map(obj => <option value={obj.College}>{obj.College}</option>)
                            }
                        </select>
                    </div>
                    <div className="form-group mt-1 col-lg-2 col-md-4 col-sm-4 col-4 ">
                        <label htmlFor='stdyr' className='me-2'><small>Student Year</small></label>
                        <select className='form-select form-select-sm' id="stdyr" onChange={event => setStudentYearfunction(event.target.value)}>
                            <option defaultChecked value="all">Select student year...</option>
                            {
                                studentYears.map(obj => <option value={obj.StudentYear}>{obj.StudentYear}</option>)
                            }
                        </select>
                    </div>
                    <div className="form-group mt-1 col-lg-2 col-md-4 col-sm-4 col-4">
                        <label htmlFor='sem' className='me-2'><small>Sem</small></label>
                        <select className='form-select form-select-sm' id="sem" onChange={event => setSemfunction(event.target.value)} >
                            <option defaultChecked value="all">Select semester...</option>
                            {
                                semesters.map(obj => <option value={obj.Semester}>{obj.Semester}</option>)
                            }
                        </select>
                    </div>
                </div>
            </div> */}
            {
                isLoading == true ? (
                    <div>
                        {/* <div className="loader">Loading...</div> */}
                        <h3 className='text-center mt-4'>Loading please wait...</h3>
                        <MoonLoader
                            className='mx-auto moonloader'
                            color="#012951"
                            loading={isLoading}
                            speedMultiplier={1}
                        />
                    </div>
                ) :
                    (<>
                        {teachers.length === 0 ?
                            (<div>
                                <h5 className='text-center mt-5'><HiEmojiSad /> Oops... No Data Found </h5>
                                <div className='text-center mt-3'>
                                    <button className='btn btn-success' onClick={gotoUploadFsTeachers}>Upload</button>
                                </div>
                            </div>
                            ) : (
                                <div className='data-table-manage-projects'>
                                    {/* <h5 className='text-start pt-1'>{selectedCollege} projects list</h5> */}
                                    {/* <nav>
                                        <small>
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item active d-inline">Showing results of -&gt; {selectedPSY}</li>
                                                {
                                                    selectedCollege != "" &&
                                                    <li className="breadcrumb-item active d-inline">{selectedCollege.toLowerCase()}</li>
                                                }
                                                {
                                                    selectedStdyr != "" &&
                                                    <li className="breadcrumb-item active d-inline">{selectedStdyr}year</li>
                                                }
                                                {
                                                    selectedSem != "" &&
                                                    <li className="breadcrumb-item active d-inline">{selectedSem.toLowerCase()}</li>
                                                }
                                            </ol>
                                        </small>
                                    </nav> */}
                                    <DataTable
                                        title='FS Teachers'
                                        columns={columns}
                                        data={filteredList}
                                        onRowClicked={handleSelectedRow}
                                        // selectableRows
                                        // selectableRowsHighlight
                                        onSelectedRowsChange={rowsSelected}
                                        // persistTableHead
                                        pointerOnHover
                                        pagination
                                        fixedHeader
                                        fixedHeaderScrollHeight='600px'
                                        highlightOnHover
                                        actions={
                                            <>
                                                <CSVLink {...csvReport}><button className='btn btn-sm btn-primary m-0' data-bs-toggle="tooltip" data-bs-placement="top" title="Export as CSV">Export</button></CSVLink>
                                            </>
                                        }
                                        subHeader
                                        subHeaderComponent={
                                            <>
                                                <button className='btn btn-sm btn-primary mb-1 me-md-2' onClick={() => gotoUploadFsTeachers()}>Add</button>
                                                {/* <button className='btn btn-sm btn-danger data-table-delete-selected mb-1'><AiOutlineDelete className='mb-1' /> Delete Selected</button> */}
                                                <input type="text" className='form-control form-control-sm datatable-search mb-1' placeholder='Search here...' value={search} onChange={(e) => setSearch(e.target.value)} />
                                            </>
                                        } />
                                </div>
                            )
                        }
                    </>)
            }
            <ToastContainer />
        </div>
    );
}

export default ManageFSTeachers;